<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <products-modal :checkGroups="true" v-model="promocode" :product-categories="productCategories"></products-modal>
      <v-data-table
              no-data-text="Нет блюд"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="promocode.products"
              :search="search"
              :options.sync="options"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка блюд... Подождите пожалуйста"
      >

        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import PromocodeService from '../../../api/PromocodeService'
    import ProductService from "../../../api/ProductService";
    import ProductsModal from "../../../components/ProductsModal";
    export default {
        name: 'ProductIndex',
        props: {
            value: Object,
            loading: Boolean
        },
        components: {ProductsModal},
      data() {
        return {
          overlay: false,
          promocode: this.value,
          search: '',
          tab: null,
          submitDialog: false,
          submitItem: null,
          options: {},
          productCategories: [],
          footerProps: {
            itemsPerPageText: 'Блюд на страницу',
            pageText: '{0}-{1} из {2}',
            itemsPerPageAllText: 'Все',
            itemsPerPageOptions: [-1]
          },
          headers: [
            {
              text: 'Название',
              value: 'name'
            },
            {
              text: 'Категория',
              value: 'category.name',
            },
            {
              text: 'Цена',
              value: 'price',
            },
            {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
          ],
        }
      },
        mounted() {
          ProductService.listByCategory().then(response => {
            this.productCategories = response.data
          });
        },
        watch: {
        },
        methods: {
          submitDelete(item = null){
            if(item){
              this.removePromocodeProduct(item)
            } else {
              //this.massDelete()
            }
          },
          removePromocodeProduct(item){
            this.loading = true
            PromocodeService.removeProduct(item.pivot.id).then(response => {
                this.loading = false
                //this.promocode.products.find(prod => prod.pivot.id == item.pivot.id)
                this.promocode.products.splice(this.promocode.products.indexOf(this.promocode.products.find(prod => prod.pivot.id == item.pivot.id)) - 1, 1);
            })
          },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
